
import React from 'react';
import { useTasks } from '@/context/TaskContext';
import NavbarLogo from './nav/NavbarLogo';
import NavbarActions from './nav/NavbarActions';

interface NavigationBarProps {
  onOpenSettings: () => void;
  onOpenTaskList: () => void;
  isLightBackground?: boolean;
}

const NavigationBar = ({ 
  onOpenSettings, 
  onOpenTaskList,
  isLightBackground = false 
}: NavigationBarProps) => {
  return (
    <nav className="fixed top-0 left-0 right-0 flex justify-between items-center px-6 py-4 z-50">
      {/* Logo Section with dynamic background detection */}
      <NavbarLogo isLightBackground={isLightBackground} />
      
      {/* Action Buttons */}
      <div className="flex items-center space-x-2">
        <NavbarActions 
          onOpenSettings={onOpenSettings}
          onOpenTaskList={onOpenTaskList}
        />
      </div>
    </nav>
  );
};

export default NavigationBar;
